import { Bell } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export default function Header({ title, subtitle }: HeaderProps) {
  const { isSubscribed } = useAuth();

  return (
    <header className="h-16 border-b border-teal/20 px-6 flex items-center justify-between bg-void-lighter/50">
      <div>
        <h2 className="text-xl font-tech font-semibold">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      </div>

      <div className="flex items-center gap-4">
        {!isSubscribed && (
          <a
            href="https://shop.velosent.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary text-sm"
          >
            Upgrade to Pro
          </a>
        )}
        <button className="p-2 text-gray-400 hover:text-white transition-colors relative">
          <Bell size={20} />
        </button>
      </div>
    </header>
  );
}
